/* import __COLOCATED_TEMPLATE__ from './system-lock.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

/////////////////////////////////////////////////////////////////////////////////////////
// system-lock - Modal dialog that cannot be closed                                    //
/////////////////////////////////////////////////////////////////////////////////////////

interface SystemLockDialogArgs {
  dialogEnabled: boolean;
  title: string;
  message: string;
}

export default class SystemLockDialog extends Component<SystemLockDialogArgs> {
  ////////////////////////////////////////////////////////////////////////////////
  // Properties                                                                 //
  ////////////////////////////////////////////////////////////////////////////////
  get _message(): string {
    return this.args.message || '';
  }
  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////
  @action close(): void {
    // No Operation - AditoolsDialog requires that a dialog should always have a close function
  }
}
